import {inject} from '@angular/core';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {ResolveFn} from '@angular/router';

import {TimecardLookupData} from '../../../common/timecard.model';
import {ITimecardLookupService, TimecardLookupServiceToken} from '../shared/providers/timecard-lookup.service';
import {RetrieveTimecardLookupSuccessful} from '../actions/lookup.action';
import {TimecardTypes} from '../../../common/timecard.enum';

export const TimecardLookupDataResolver: ResolveFn<{ [key in keyof typeof TimecardTypes]?: TimecardLookupData }> = (
): Observable<{ [key in keyof typeof TimecardTypes]?: TimecardLookupData }> => {
  const timecardLookupService: ITimecardLookupService = inject(TimecardLookupServiceToken);
  const store: Store = inject(Store);

  return timecardLookupService.retrieveAllTimecardLookupData().pipe(
    tap((timecardLookup: { [key in keyof typeof TimecardTypes]?: TimecardLookupData }) => {
      store.dispatch(RetrieveTimecardLookupSuccessful(timecardLookup));
    })
  );
};
